<template>
<div>
  <img id="bg" alt="">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-7 col-lg-5">
        <div class="login">

          <div id="img">
            <img class="image_stars" src="../../assets/fern_light_green.jpg"  alt="logo">
            <img class="image_logo" src="../../assets/pura_logo.png"  alt="logo_text">
          </div>


            <div>
              <div class="login-form-container">

                <h2 class="portal-title">Staff Sign In </h2>

                <div class="d-flex justify-content-center">      
                  <q-spinner
                    v-if="loading"
                    color="primary"
                    size="3em"
                /></div>

                <div class="form-group">
                    <q-btn
                        v-if="isLocalDevelopment"
                        outlined
                        class="form-button-sso"
                        color='white'
                        no-caps
                        @click="openLocalLogin"
                    >
                      Log in for local testing
                    </q-btn>
                    <q-btn 
                        v-else
                        outlined
                        class="form-button-sso"
                        color='white'
                        no-caps
                        @click="microsoftSSO"
                    >
                    <font-awesome-icon icon="fa-brands fa-windows" 
                        color="blue" />
                        &nbsp;  Log in with Microsoft
                    </q-btn>
                </div>

                <q-dialog v-model="localLoginOpen">
                  <q-card class="local-login-dialog">
                    <q-card-section class="row items-center">
                      <div>
                        <div class="text-h6">Choose a test account</div>
                        <div class="text-caption text-grey-7">
                          Each account exercises a different local role or permission scope.
                        </div>
                      </div>
                      <q-space />
                      <q-btn icon="close" flat round dense v-close-popup aria-label="Close" />
                    </q-card-section>

                    <q-separator />

                    <q-card-section v-if="accountsLoading" class="text-center q-pa-lg">
                      <q-spinner color="primary" size="2.5em" />
                    </q-card-section>

                    <q-list v-else separator>
                      <q-item
                        v-for="testAccount in localAccounts"
                        :key="testAccount.email"
                        clickable
                        v-ripple
                        :disable="loading"
                        @click="loginLocally(testAccount.email)"
                      >
                        <q-item-section>
                          <q-item-label>{{ testAccount.name }}</q-item-label>
                          <q-item-label caption>
                            {{ testAccount.email }} · {{ formatRole(testAccount.role) }}
                          </q-item-label>
                          <q-item-label caption>{{ testAccount.description }}</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                          <q-icon name="login" color="primary" />
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-card>
                </q-dialog>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>


import { PublicClientApplication } from '@azure/msal-browser';
import api from "@/services/api/api";
import notify from '@/services/util/notify';
import { initialiseEvents } from "@/services/events/event-initialiser.js"


const StaffLoginComponent = {
  name: "staffLogin",
  data() {
    return {
      isLogged: false,
      loading: false,
      account: undefined,
      localLoginOpen: false,
      accountsLoading: false,
      localAccounts: [],
    };
  },

  computed: {
    isLocalDevelopment() {
      return process.env.VUE_APP_ENV_MODE === 'LOCAL';
    },
  },

    /**
   * Clear the sessionStorage (logs out the user) and set isLogged to false.
   */
  async created() {
    if (!this.isLocalDevelopment) {
      this.$msalInstance = new PublicClientApplication(
        this.$store.state.msalConfig,
      );
    }
    this.isLogged = false;
    sessionStorage.clear();
  },

  methods: {

    completeLogin(response) {
      sessionStorage.setItem('authToken', response.data.authToken);
      initialiseEvents();
      this.localLoginOpen = false;
      this.loading = false;
      this.$router.push({name: 'clientDemographic'});
    },

    showLoginError(error) {
      this.loading = false;
      notify.error(error.response?.data ?? 'Error logging in', 'top');
    },

    async openLocalLogin() {
      this.localLoginOpen = true;
      if (this.localAccounts.length) return;

      this.accountsLoading = true;
      try {
        const response = await api.users.getLocalLoginAccounts();
        this.localAccounts = response.data;
      } catch (error) {
        this.localLoginOpen = false;
        this.showLoginError(error);
      } finally {
        this.accountsLoading = false;
      }
    },

    async loginLocally(email) {
      this.loading = true;
      try {
        const response = await api.users.loginStaffLocally(email);
        this.completeLogin(response);
      } catch (error) {
        this.showLoginError(error);
      }
    },

    formatRole(role) {
      return String(role || '')
        .split('_')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
    },


    /**
     * Single sign on
     */
    async microsoftSSO() {

      await this.$msalInstance
        // Request an ID token with a sign-in name claim.
        .loginPopup({ scopes: ['openid', 'profile', 'email'] })
        .then((account) => {

          this.loading = true;

          const accounts = this.$msalInstance.getAllAccounts();

          this.account = accounts[0];
          this.$emitter.emit("login", this.account);

          api.users
            // The server verifies this application-scoped ID token.
            .loginStaffWithSSO({ ssoLoginToken: account.idToken })
            .then(this.completeLogin)
            .catch(this.showLoginError)
        })
        .catch(this.showLoginError);
    },
  }
}

export default StaffLoginComponent;
</script>

<style scoped>
@import '../../assets/styles/login.css';

.local-login-dialog {
  width: 560px;
  max-width: 92vw;
}

</style>


